import React, { useState, useRef, useEffect } from "react";
import HelmetImage from "../../../assets/Blackwomen/handsoncomputer4.jpg";
import BlogImage1 from "../../../assets/Dr.Naomi Website.webp";
import BlogImage2 from "../../../assets/AboutImage1.jpg";
import Footer from "../../../components/Footer";
import Navbar from "../../../components/Navbar";
import { Helmet } from "react-helmet";


const BlogCSS = `
  .blog-grid {
    display: grid;
    gap: 15px; /* Adjust gap as needed */
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); /* Adjust minmax width */
  }

  @media (min-width: 768px) {
    .blog-grid {
      gap: 10px; /* Adjust gap for medium screens */
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); /* Adjust minmax width */
    }
  }

  .blog-card {
    background-white rounded-xl border border-black;
    display: flex;
    flex-direction: column; /* Ensure content stacks vertically */
  }

  .blog-card .relative {
    position: relative;
    overflow: hidden; /* Clip any overflowing content */
  }

  .blog-card img {
    width: 100%;
    height: auto; /* Helmettain aspect ratio */
    object-fit: cover;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    max-height: 180px; /* Adjust the maximum height of the image */
  }

  .blog-card .content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
  }

  .blog-card .category {
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    background-color: #CFF098;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  .blog-card h3 {
    font-size: 1.125rem;
    font-style: italic;
    font-weight: 600;
    color: black;
    margin-bottom: 0;
  }

  .blog-card p {
    font-size: 0.875rem;
    color: black;
    font-weight: light;
    margin-bottom: 0;
  }

  .blog-card a {
    display: block;
    color: #6E5E44;
    text-decoration: underline;
    font-size: 0.875rem;
    margin-top: 0.75rem;
  }

  .blog-grid > * {
    margin-bottom: 15px; /* Default bottom margin (matches default gap) */
  }

  @media (min-width: 768px) {
    .blog-grid > * {
      margin-bottom: 10px; /* Default bottom margin for medium screens */
    }
  }

  .blog-grid > *:nth-last-child(-n + var(--last-row-count)) {
    margin-bottom: 0;
  }
`;

function Blog() {

  <Helmet>
<title>Web Design Tips for Female Founders | Woaom Web Design Blog</title>
  <meta
    name="description"
    content="Browse web design, branding, and digital marketing tips to help your business grow — made for women entrepreneurs."
  />
  <meta
    name="keywords"
    content="web design tips, female founder blog, branding advice, launch strategy posts, entrepreneur website tips, blog for creatives, business growth tips, website strategy blog, digital presence education, seo for women, small business blog, blog for coaches, tech tutorials for founders, content creation help, online business education, flodesk tips, firebase tutorials, react website how-tos, branding trends, business mindset blog, funnel strategy posts, brand visibility ideas, marketing for women, creative process blog, ux/ui tips, design system guides, website audit advice, startup web advice, founder storytelling, blog for digital CEOs"
  />
</Helmet>

  const [selectedCategory, setSelectedCategory] = useState("All");
  const [currentFeature, setCurrentFeature] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 9;
  const blogSectionRef = useRef(null);
  const blogGridRef = useRef(null);
    const [lastRowCount, setLastRowCount] = useState(0);

  const categories = ["All", "Email Marketing", "Virtual Assistant", "Pricing Strategy", "Website", "Marketing", "Coaching"];
  const allPosts = [
    {
      image: BlogImage1,
      category: "Website",
      title: "Essential Website Pages for Women Entrepreneurs",
      summary: "Essential Website Pages for Women Entrepreneurs",
      link: "/essentialswebsitepages"

    },
    {
      image: BlogImage2,
      category: "Website",
      title: "5 Signs Your Women-Owned Business Website Needs a Redesign",
      summary: "5 Signs Your Women-Owned Business Website Needs a Redesign",
      link: "/websiteredesignsigns"
    },
    // {
    //   image: BlogImage3,
    //   category: "Coaching",
    //   title: "Empowering Leadership Coaches",
    //   summary: "How VAs streamline tasks for coaching pros.",
    //   link: "/"
    // },
 
    // {
    //   image: BlogImage2,
    //   category: "Virtual Assistant",
    //   title: "Delegating for Growth: Hiring a VA",
    //   summary: "Unlock your time by outsourcing key tasks.",
    //   link: "/"
    // },
    // {
    //   image: BlogImage3,
    //   category: "Pricing Strategy",
    //   title: "The Art of Value-Based Pricing",
    //   summary: "Pricing your services for maximum impact and profit.",
    //   link: "/"
    // },
    
    // {
    //   image: BlogImage3,
    //   category: "Coaching",
    //   title: "Building a Successful Coaching Practice",
    //   summary: "Strategies for growth and client acquisition.",
    //   link: "/"
    // },
  ];
  const featuredPosts = allPosts.slice(0, 3);

  const filteredPosts = selectedCategory === "All"
    ? allPosts
    : allPosts.filter(post => post.category === selectedCategory);

  // Pagination Logic
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  const handlePrevPage = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1));
    if (blogSectionRef.current) {
      blogSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNextPage = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages));
    if (blogSectionRef.current) {
      blogSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    if (blogSectionRef.current) {
      blogSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePrevFeature = () => {
    setCurrentFeature((prev) => (prev === 0 ? featuredPosts.length - 1 : prev - 1));
  };
  const handleNextFeature = () => {
    setCurrentFeature((prev) => (prev === featuredPosts.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const updateLastRowCount = () => {
      if (blogGridRef.current) {
        const grid = window.getComputedStyle(blogGridRef.current);
        const columnCount = parseInt(grid.getPropertyValue('grid-template-columns').split(' ').length);
        const itemCount = currentPosts.length;
        setLastRowCount(itemCount % columnCount === 0 ? columnCount : itemCount % columnCount);
        blogGridRef.current.style.setProperty('--last-row-count', itemCount > 0 ? (itemCount % columnCount === 0 ? columnCount : itemCount % columnCount) : 0);
      }
    };

    updateLastRowCount();
    window.addEventListener('resize', updateLastRowCount);
    return () => window.removeEventListener('resize', updateLastRowCount);
  }, [currentPosts.length]);

  return (
    <Helmet className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
      <style>{BlogCSS}</style>
      <title>Blog | Empowering Women Entrepreneurs | Woaom Web Design</title>
      <meta
        name="description"
        content="Read insightful blog posts tailored to help women entrepreneurs grow their online presence through web design and SEO."
      />
      <meta
        name="keywords"
        content="website designer near me, website design near me, web designers near me, website designers, website builders near me, website designers near me, local website designers, web designer near me, web design company near me, web designing near me, professional website designer, local web designers, local web designer, local website designers near me"
      />
      <section className="bg-[#F7F3F2]">
        {/* Hero */}
        <div
          className="relative h-auto bg-cover bg-center"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${HelmetImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 bg-[#CFF098] font-semibold">Our Blog</h1>
            </div>
          </div>
        </div>
        {/* Blog + Sidebar Layout */}
        <div ref={blogSectionRef} className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20 flex flex-col md:flex-row">
          {/* Blog Cards */}
          <div className="w-full md:w-3/4 pr-6">
            <div ref={blogGridRef} className="blog-grid">
              {currentPosts.map((post, index) => (
                <div key={index} className="blog-card">
                  <div className="relative">
                    <img
                      src={post.image}
                      alt="client portal template, notion-style client dashboard, CRM for coaches, portal for 1:1 clients, private course dashboard, membership site template, custom dashboard for online business, onboarding portal for clients, student dashboard template, dashboard for course creators"
                      className="w-full h-auto object-cover rounded-t-xl"
                      style={{ maxHeight: '280px' }}
                    />
                    <span className="absolute top-0.75 left-0.75 bg-[#CFF098] px-2 py-1 text-xs font-bold text-black uppercase category">
                      {post.category}
                    </span>
                  </div>
                  <div className="content">
                    <h3 className="italic text-center text-lg uppercase font-semibold text-black">
                      {post.title}
                    </h3>
                    <p className="text-sm text-center text-black font-light">
                      {post.category}
                    </p>
                    <a
                      href={post.link}
                      className="block text-center text-[#6E5E44] underline text-sm"
                    >
                      Read Full Post →
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Sidebar */}
          <div className="w-full md:w-1/4 md:pl-6 md:border-l md:border-black mt-10 md:mt-0">
            {/* Filter Dropdown */}
            <label className="block mb-2 text-black font-semibold italic">Filter by Category:</label>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="w-full p-2 rounded-md border border-black bg-white text-black"
            >
              {categories.map((category, index) => (
                <option key={index} value={category}>
                  {category}
                </option>
              ))}
            </select>
            {/* Featured Posts */}
            <h2 className="text-xl font-bold text-black mt-6 mb-4">Featured Posts</h2>
            <div className="bg-[#F7F3F2] rounded-lg p-4 relative">
              <div className="relative">
                <img
                  src={featuredPosts[currentFeature].image}
                  alt={featuredPosts[currentFeature].title}
                  className="w-full h-48 object-cover rounded-md mb-3"
                />
                <span className="absolute top-2 left-2 bg-[#CFF098] px-2 py-1 text-xs font-bold text-black uppercase">
                  {featuredPosts[currentFeature].category}
                </span>
              </div>
              <h3 className="italic text-black text-xl text-center mb-2">
                {featuredPosts[currentFeature].title}
              </h3>
              <p className="text-sm text-center text-black font-light mt-2">
                {featuredPosts[currentFeature].summary}
              </p>
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={handlePrevFeature}
                  className="bg-[#CFF098] p-2 rounded-full text-black "
                >
                  &#8592;
                </button>
                <button
                  onClick={handleNextFeature}
                  className="bg-[#CFF098] p-2 rounded-full text-black"
                >
                  &#8594;
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        {filteredPosts.length > postsPerPage && (
          <div className="mx-auto w-full max-w-7xl px-5 py-8 md:px-10 flex justify-center items-center">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className=" text-black px-4 py-2 rounded-md mr-2 disabled:opacity-50"
            >
              &#8592;
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
              <button
                key={number}
                onClick={() => handlePageClick(number)}
                className={`px-3 py-2 rounded-md mx-1 ${
                  currentPage === number ? " text-black" : "text-black"
                }`}
              >
                {number}
              </button>
            ))}
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="text-black px-4 py-2 rounded-md ml-2 disabled:opacity-50"
            >
              &#8594;
            </button>
          </div>
        )}
        <Footer />
      </section>
    </Helmet>
  );
}

export default Blog;